import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { City } from "../../core/model/city";
import { Network } from "../../core/model/network";
import { CityService } from "../../core/service/city.service";
import { NetworkService } from "../../core/service/network.service";

@Component({
  selector: "app-edit-city",
  templateUrl: "./edit-city.component.html",
  styleUrls: ["./edit-city.component.scss"],
})
export class EditCityComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  cityId: number;
  city: City;
  networks: Network[];

  constructor(
    private _router: Router,
    private _cityService: CityService,
    private _networkService: NetworkService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      network: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.cityId = params["cityId"];
      this.getCity(this.cityId);
      this.getNetworks();
    });
  }

  getCity(cityId) {
    this.loading = true;
    this._cityService.getCityById(cityId).subscribe(
      (data) => {
        this.city = {
          ...data,
          network: data.network ? { ...data.network } : new Network(),
        };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getNetworks() {
    this._networkService.getAllNetworks().subscribe(
      (data) => {
        this.networks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    const selected = (this.networks || []).find(
      (n) => n.id === this.city.network.id
    );
    if (selected) {
      this.city.network = { ...selected };
    }

    this._cityService
      .putCity(this.city)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/city");
  }
}
